import React from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const schools = [
    {
        "img": require('./img/schools/sjc.jpg'),
        "title": "St Joseph's College Hr Sec School",
        "place": "Tiruchirapalli",
        "website":"https://www.stjosephcollegeschool.com/"
    },
    {
        "img": require('./img/schools/mdu stmarys.jpg'),
        "title": "St Mary's Hr. Sec. School",
        "place": "Madurai",
        "website":"https://stmaryshssmdu.in/"
    },
    {
        "img": require('./img/schools/dgl stmarys.jpg'),
        "title": "St Mary's Hr. Sec. School",
        "place": "Dindigul",
        "website":"https://stmarysdindigul.org/"
    },
    {
        "img": require('./img/schools/stxaviers.jpg'),
        "title": "St Xavier's Hr. Sec. School",
        "place": "Palayamkottai",
        "website":"https://www.stxaviershsspalay.com/"
    },
    {
        "img": require('./img/schools/debritto.jpg'),
        "title": "De Britto Hr. Sec. School",
        "place": "Devakottai",
        "website":"https://www.debrittohssdvk.org/"
    },
    {
        "img": require('./img/schools/oriyur.jpg'),
        "title": "St Arulanandar Hr. Sec. School",
        "place": "Oriyur",
        "website":"https://www.starulanandarhssoriyur.com/"
    },
    {
        "img": require('./img/schools/sxs thothukudi.jpg'),
        "title": "St Xavier's Hr. Sec. School",
        "place": "Thoothukudi",
        "website":"https://stxaviersthoothukudi.com/"
    },
    {
        "img": require('./img/schools/carmel.jpg'),
        "title": "Carmel Hr. Sec. School",
        "place": "Nagercoil",
        "website":"/"
    },
    {
        "img": require('./img/schools/loyolatech.jpg'),
        "title": "Loyola Tech School",
        "place": "Dindigul",
        "website":"https://loyolatechschool.com/"
    },
    {
        "img": require('./img/schools/marysthope.jpeg'),
        "title": "St. Mary's Tope Middle School",
        "place": "Trichy",
        "website":"/"
    },{
        "img": require('./img/schools/primaryoriyur.jpeg'),
        "title": "St.Arulanandar Primary School",
        "place": "Oriyur",
        "website":"/"
    },
    {
        "img": require('./img/schools/rcariamangalam.jpeg'),
        "title": "RC Middle School",
        "place": "Ariyamangalam, Trichy",
        "website":"/"
    },
    {
        "img": require('./img/schools/rcpala.jpg'),
        "title": "RC Primary School",
        "place": "Palamalai, Kodaikanal",
        "website":"/"
    },
    {
        "img": require('./img/schools/pallangi.jpeg'),
        "title": "Gandhi Primary School",
        "place": "Pallangi, Kodaikanal",
        "website":"/"
    },
    {
        "img": require('./img/schools/puthupathur.jpg'),
        "title": "Nethaji Primary School",
        "place": "Puthuputhur, Kodaikanal",
        "website":"/"
    }
]

export default function SchoolList() {
  return (
    <div style={{background: "linear-gradient(135deg, #f8fafc 60%, #e0e7ef 100%)", minHeight: "100vh"}}>
      <div className="container-fluid px-0 py-5">
        <div className="row mx-0 justify-content-center pt-5">
          <div className="col-lg-8">
            <div className="text-center position-relative mb-4">
              <h6 className="d-inline-block position-relative text-primary text-uppercase pb-2" style={{letterSpacing: 2}}>Madurai Jesuit Schools</h6>
              <h1 className="display-5 fw-bold mb-3" style={{color: "#1a2740", fontWeight: 700, letterSpacing: 1}}>List of Our Schools</h1>
              <p className="lead" style={{color: "#374151"}}>Explore the vibrant network of Jesuit schools in Madurai Province, each fostering excellence and holistic development.</p>
            </div>
          </div>
        </div>
        <div className='container'>
          <Row className="g-4 justify-content-center">
            {schools.map((item, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className='d-flex align-items-stretch'>
                <Card className="shadow-lg border-0 school-card" style={{transition: "transform 0.2s", borderRadius: 18, overflow: "hidden", background: "#fff", width: "100%", minWidth: 0, display: "flex", flexDirection: "column", height: "100%", maxWidth: "340px", margin: "auto"}}>
                  <div style={{overflow: "hidden", borderTopLeftRadius: 18, borderTopRightRadius: 18, width: "100%"}}>
                    <Card.Img className='img-fluid card-img-top' variant="top" src={item.img} style={{height: "200px", width: "100%", objectFit: "cover", transition: "transform 0.3s"}} />
                  </div>
                  <Card.Body className="d-flex flex-column justify-content-between" style={{padding: "1.25rem", flex: "1 1 auto"}}>
                    <Card.Title className="mb-2" style={{fontWeight: 700, color: "#1a2740", fontSize: "1.15rem"}}>{item.title}</Card.Title>
                    <div className="mb-2" style={{fontWeight: 500, color: "#2563eb", fontSize: "1rem"}}>{item.place}</div>
                    <div className="mt-auto">
                      <Button href={item.website} variant="primary" target="_blank" rel="noopener noreferrer" style={{borderRadius: 8, fontWeight: 600, padding: "8px 20px", fontSize: "1rem", width: "100%"}}>
                        View More
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </div>
      <style>{`
        .school-card {
          min-height: 370px;
          max-width: 340px;
        }
        @media (max-width: 575.98px) {
          .school-card {
            max-width: 100%;
            min-height: 340px;
          }
        }
        .school-card .card-img-top {
          height: 200px;
          object-fit: cover;
          width: 100%;
        }
        .school-card:hover .card-img-top {
          transform: scale(1.06);
        }
        .school-card:hover {
          box-shadow: 0 8px 32px 0 rgba(44,62,80,0.18);
          transform: translateY(-4px) scale(1.02);
        }
      `}</style>
    </div>
  )
}
